import { c as _c } from "react/compiler-runtime";
import { ArrowNarrowLeftIcon } from '@systemeio/icons';
import RuleSave from 'modules/automation-rules/components/rule-save';
import { useRuleState } from 'modules/automation-rules/hooks/use-rule-state';
import { SpecificTriggerRulesProps } from 'modules/automation-rules/specific-trigger-rules';
import React, { useRef, useState } from 'react';
import { Button } from 'shared/components';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import useMediaQuery from 'shared/hooks/use-media-query';
import { CONTENT_HORIZONTAL_PADDING_CLASSNAME } from 'shared/layout/constants/layout-class-names';
import { twJoin } from 'tailwind-merge';
import { SpecificTriggerRule } from './specific-trigger-rule';
export interface SpecificTriggerRuleCreateProps extends SpecificTriggerRulesProps {
  onClose: () => void;
}
const SpecificTriggerRuleCreate = t0 => {
  const $ = _c(45);
  const {
    availableTriggersData,
    getRelatedAndUnrelatedTriggersData,
    specificTriggerRulesData,
    customAddTriggerHandler,
    noRelatedMessage,
    onClose
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const {
    isMobile
  } = useMediaQuery();
  const {
    tempState,
    setTempState,
    errors,
    setErrors,
    clearState
  } = useRuleState();
  const maxTriggerId = useRef(0);
  const maxActionId = useRef(0);
  const [isFetching, setIsFetching] = useState(false);
  let t1;
  if ($[0] !== clearState || $[1] !== onClose) {
    t1 = () => {
      clearState();
      onClose();
    };
    $[0] = clearState;
    $[1] = onClose;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const close = t1;
  let t2;
  if ($[3] !== availableTriggersData || $[4] !== close || $[5] !== specificTriggerRulesData) {
    t2 = async () => {
      await specificTriggerRulesData.mutate();
      await availableTriggersData.mutate();
      close();
    };
    $[3] = availableTriggersData;
    $[4] = close;
    $[5] = specificTriggerRulesData;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const afterSave = t2;
  let t3;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <ArrowNarrowLeftIcon />;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t) {
    t4 = t("dashboard.funnel.automation_rules.back");
    $[8] = t;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== close || $[11] !== isFetching || $[12] !== t4) {
    t5 = <Button className="w-fit" disabled={isFetching} onClick={close} variant="ghost-gray" size="sm">{t3}{t4}</Button>;
    $[10] = close;
    $[11] = isFetching;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== afterSave || $[15] !== isFetching || $[16] !== setErrors || $[17] !== tempState) {
    t6 = <RuleSave className="tablet:flex hidden" setErrors={setErrors} afterSave={afterSave} isFetching={isFetching} setIsFetching={setIsFetching} rule={tempState} size="md" />;
    $[14] = afterSave;
    $[15] = isFetching;
    $[16] = setErrors;
    $[17] = tempState;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  let t7;
  if ($[19] !== t5 || $[20] !== t6) {
    t7 = <div className="flex items-center justify-between gap-4">{t5}{t6}</div>;
    $[19] = t5;
    $[20] = t6;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  let t8;
  if ($[22] !== availableTriggersData.data || $[23] !== customAddTriggerHandler || $[24] !== errors || $[25] !== getRelatedAndUnrelatedTriggersData || $[26] !== isFetching || $[27] !== noRelatedMessage || $[28] !== setTempState || $[29] !== tempState) {
    t8 = <SpecificTriggerRule noRelatedMessage={noRelatedMessage} isFetching={isFetching} tempState={tempState} setTempState={setTempState} errors={errors} maxActionId={maxActionId} maxTriggerId={maxTriggerId} availableTriggers={availableTriggersData.data} getRelatedAndUnrelatedTriggersData={getRelatedAndUnrelatedTriggersData} customAddTriggerHandler={customAddTriggerHandler} />;
    $[22] = availableTriggersData.data;
    $[23] = customAddTriggerHandler;
    $[24] = errors;
    $[25] = getRelatedAndUnrelatedTriggersData;
    $[26] = isFetching;
    $[27] = noRelatedMessage;
    $[28] = setTempState;
    $[29] = tempState;
    $[30] = t8;
  } else {
    t8 = $[30];
  }
  const t9 = isMobile && CONTENT_HORIZONTAL_PADDING_CLASSNAME;
  let t10;
  if ($[31] !== t9) {
    t10 = twJoin("bg-bg-primary border-border-100 tablet:hidden fixed inset-x-0 bottom-0 z-40 flex border-t py-4", t9);
    $[31] = t9;
    $[32] = t10;
  } else {
    t10 = $[32];
  }
  let t11;
  if ($[33] !== afterSave || $[34] !== isFetching || $[35] !== setErrors || $[36] !== tempState) {
    t11 = <RuleSave className="w-full" setErrors={setErrors} afterSave={afterSave} isFetching={isFetching} setIsFetching={setIsFetching} rule={tempState} size="md" />;
    $[33] = afterSave;
    $[34] = isFetching;
    $[35] = setErrors;
    $[36] = tempState;
    $[37] = t11;
  } else {
    t11 = $[37];
  }
  let t12;
  if ($[38] !== t10 || $[39] !== t11) {
    t12 = <div className={t10}>{t11}</div>;
    $[38] = t10;
    $[39] = t11;
    $[40] = t12;
  } else {
    t12 = $[40];
  }
  let t13;
  if ($[41] !== t12 || $[42] !== t7 || $[43] !== t8) {
    t13 = <div className="tablet:pb-0 flex flex-col gap-4 pb-18">{t7}{t8}{t12}</div>;
    $[41] = t12;
    $[42] = t7;
    $[43] = t8;
    $[44] = t13;
  } else {
    t13 = $[44];
  }
  return t13;
};
export default SpecificTriggerRuleCreate;